import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { DateTime } from 'luxon';

import Modal from '../../../components/Modal/Modal';
import { displayField, formatValue, getLogPresentation } from '../logPresentation';

const LogDetails = ({ log, onClose }) => {
  const [showJson, setShowJson] = useState(false);
  const type = log?.type?.name;
  const { title, summary, changes } = getLogPresentation({
    type, action: log?.action, data: log?.data
  });
  const timestamp = log?.created_at
    ? DateTime.fromISO(log.created_at, { zone: 'utc' }).toLocal()
      .toFormat('yyyy-MM-dd HH:mm:ss ZZZZ')
    : '';
  const person = log?.user;
  const userName = person
    ? `${person.name || ''} ${person.last_name || ''}`.trim() || person.email
    : 'System';

  return (
    <Modal
      visible={Boolean(log)}
      toggleVisible={onClose}
      title={title}
      subTitle={summary}
      hideSaveBtn
    >
      <div className="w-[760px] max-w-full max-h-[70vh] overflow-auto customScroll space-y-[16px]">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-[12px] text-[13px]">
          <div>
            <div className="text-text-muted">Time</div>
            <div>{timestamp}</div>
          </div>
          <div>
            <div className="text-text-muted">User</div>
            <div>{userName}</div>
          </div>
          <div>
            <div className="text-text-muted">Action</div>
            <div>{log?.action}</div>
          </div>
        </div>
        {changes.length > 0 && (
          <div>
            <div className="font-semibold mb-[8px]">Changed fields</div>
            <div className="overflow-auto">
              <table className="w-full text-[13px] text-left">
                <thead>
                  <tr className="border-b">
                    <th className="p-[8px]">Field</th>
                    <th className="p-[8px]">Before</th>
                    <th className="p-[8px]">After</th>
                  </tr>
                </thead>
                <tbody>
                  {changes.map(({ field, before, after }) => (
                    <tr key={field} className="border-b align-top">
                      <td className="p-[8px] font-medium">{displayField(field)}</td>
                      <td className="p-[8px] break-all">{formatValue(before)}</td>
                      <td className="p-[8px] break-all">{formatValue(after)}</td>
                    </tr>
                ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
        <button type="button" className="text-primary text-[13px]" onClick={() => setShowJson(!showJson)}>
          {showJson ? 'Hide raw data' : 'Show raw data'}
        </button>
        {showJson && (
          <pre className="text-[12px] whitespace-pre-wrap break-all bg-input-bg p-[12px] rounded-[6px]">
            {JSON.stringify(log?.data, null, 2) || 'No data'}
          </pre>
        )}
      </div>
    </Modal>
  );
};

LogDetails.propTypes = {
  log: PropTypes.shape({
    action: PropTypes.string,
    created_at: PropTypes.string,
    data: PropTypes.shape({}),
    type: PropTypes.shape({ name: PropTypes.string }),
    user: PropTypes.shape({
      name: PropTypes.string,
      last_name: PropTypes.string,
      email: PropTypes.string
    })
  }),
  onClose: PropTypes.func
};

LogDetails.defaultProps = {
  log: null,
  onClose: () => {}
};

export default LogDetails;
